export default __webpack_public_path__ + "static/media/javascript.fa3ecb79.svg";